export default __webpack_public_path__ + "static/media/Zaibatsu_Logo.a7c31170.svg";